import validate from "C:/Install/Projects/lk_creative/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "C:/Install/Projects/lk_creative/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("C:/Install/Projects/lk_creative/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/auth.js")
}